import { render, staticRenderFns } from "./DataCellLink.vue?vue&type=template&id=220e39a2&"
import script from "./DataCellLink.vue?vue&type=script&lang=js&"
export * from "./DataCellLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports